export default __webpack_public_path__ + "static/media/google-play-fr.8402d4a5.png";